<template>
    <div class="grid__container">
        <button
            type="button"
            class="button button_theme_reset report-problems__top-mobile"
            @click="goBack">
            <IconCloseSmall class-name="icon-stroke icon_color_gray" />
        </button>
        <div class="report-problems__top">
            <div class="report-problems__top-title">
                <h1>Обращение в техническую поддержку</h1>
            </div>

            <STBaseButton
                modify="button_theme_reset report-problems__top-button"
                text="Вернуться назад"
                @click="goBack" />
        </div>

        <ReportProblemsForm 
            @response="showResponse" />

        <STPopup
            ref="responsePopup"
            :icon-close-big="false"
            :is-custom-event-close="true"
            modify="popup_theme_slide-top-mobile report-problems__popup"
            @popup-close-custom="goBack">
            <h2 v-html="`${responseTitle} <br> ${responseDescription}`" />

            <STBaseButton
                modify="button_size_small button_full_width report-problems__popup-button"
                text="Вернуться назад"
                @click="goBack" />
        </STPopup>
    </div>
</template>

<script>
import IconCloseSmall from '../../components/Icons/CloseSmall.vue';
import ReportProblemsForm from '../../components/Forms/ReportProblemsForm/ReportProblemsForm.vue';
export default {
    name: 'ReportProblems',

    components: {
        IconCloseSmall,
        ReportProblemsForm
    },

    data() {
        return {
            responseTitle      : '',
            responseDescription: ''
        };
    },

    methods: {
        goBack() {
            this.$router.back();
        },

        showResponse(data) {
            this.responseTitle = data.title;
            this.responseDescription = data.description;
            this.$refs.responsePopup.open();
        }
    }
};
</script>

<style lang="scss">
@import "ReportProblems";
</style>
